<script>
export default {
  data(){
    return{
      // loading: false
    }
  },
  props:{
    loading:{
      type:Boolean,
      default: true
    }
  }
  // mounted(){
  //   this.loading = true
  //   setTimeout(() => {
  //     this.loading = false
  //   }, 4000);
  // }
}
</script>
<template>
  <div>
    <div :class="{ 'is-loading': loading }" v-if="loading">
      <div class="preloader-component">
        <div class="status">
          <div class="spinner-chase">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <slot />
    </div>
    <div v-else>
      <div class="is-loading">
        <div class="preloader-component">
          <div class="empty-table">
            <img src="@/assets/images/exclamation.svg" class="me-2" />
            <div class="empty-table-text">موردی ثبت نشده است</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 2;
  width: 100%;
  height: 140px;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
.empty-table {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  flex-direction: column;
}
.empty-table-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
}
</style>
